import React, { useRef } from 'react';
import { ArrowUpRight } from 'lucide-react';
import { SERVICES, WHATSAPP_LINK } from '../data/mock';

function ServiceCard({ s, idx }) {
  const ref = useRef(null);

  const onMove = (e) => {
    const el = ref.current; if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    el.style.setProperty('--mx', `${x}%`);
    el.style.setProperty('--my', `${y}%`);
  };

  return (
    <a
      ref={ref} onMouseMove={onMove}
      href={WHATSAPP_LINK(`Olá! Quero saber mais sobre ${s.title}.`)}
      target="_blank" rel="noopener noreferrer"
      className={`spotlight cursor-hover group relative reveal block py-12 md:py-16 px-2 md:px-10 border-b border-white/8 ${
        idx % 2 === 0 ? 'md:border-r' : ''
      } overflow-hidden`}
    >
      <div className="flex items-start justify-between gap-6 relative">
        <div className="flex-1">
          <span className="font-mono-label text-[#8E8B85]">SERVIÇO · {s.number}</span>
          <h3 className="mt-4 font-display-tight text-[42px] md:text-[60px] leading-[0.95] text-[#F5F1E8] transition-all duration-500">
            {s.title}
          </h3>
          <p className="mt-3 text-[16px] md:text-[18px] text-[#8E8B85] max-w-[440px]">{s.short}</p>
        </div>
        <div className="shrink-0 w-14 h-14 rounded-full border border-white/20 flex items-center justify-center text-[#F5F1E8] group-hover:bg-[#C8FF61] group-hover:border-[#C8FF61] group-hover:text-[#0A0B0E] group-hover:rotate-45 transition-all duration-500">
          <ArrowUpRight size={20} />
        </div>
      </div>

      <ul className="mt-8 space-y-3">
        {s.items.map((item, i) => (
          <li key={i} className="flex items-start gap-3 text-[15px] text-[#F5F1E8]/85">
            <span className="mt-2 inline-block w-1.5 h-1.5 rounded-full bg-[#C8FF61] shrink-0" />
            <span>{item}</span>
          </li>
        ))}
      </ul>

      {/* Hover label */}
      <span className="absolute bottom-6 right-6 font-mono-label text-[#C8FF61] opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-2 group-hover:translate-y-0">
        VAMOS CONVERSAR →
      </span>
    </a>
  );
}

export default function Services() {
  return (
    <section id="servicos" className="py-24 md:py-36 relative">
      <div className="thesis-container">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-end border-b border-white/8 pb-8 md:pb-12">
          <div className="md:col-span-2">
            <span className="font-mono-label text-[#8E8B85]">(03) — Serviços</span>
          </div>
          <div className="md:col-span-7 reveal">
            <h2 className="font-display-tight text-[44px] md:text-[80px] leading-[0.92] text-[#F5F1E8]">
              O que eu faço <span className="font-serif-italic kinetic-grad">pelo seu</span> negócio
            </h2>
          </div>
          <div className="md:col-span-3 md:text-right reveal">
            <p className="text-[15px] text-[#8E8B85] leading-relaxed max-w-[300px] md:ml-auto">
              4 frentes pensadas pra marcas que querem crescer com consistência, sem gastar fortuna.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
          {SERVICES.map((s, idx) => (
            <ServiceCard key={s.id} s={s} idx={idx} />
          ))}
        </div>
      </div>
    </section>
  );
}
